/*
  TRWS product page content (2026-11-03). Runs on every product template
  (default, store-locator, presale-reserve). Changes no buying behavior.

  1. Fit Guru card: Guru Tip, Buy This If and Don't Buy If are pulled into a styled card.
  2. Display fix for the "AMPA" typo (source descriptions are now fixed; this is a safety net).
  3. Spec table (snippets/trws-spec-table.liquid) moved into the description, after the card.
*/
(() => {
  if (window.__trwsPdpContentLoaded) return;
  window.__trwsPdpContentLoaded = true;

  const root = document.querySelector('product-info[id^="MainProduct"]');
  if (!root) return;

  const description = root.querySelector('.product__description');
  if (description && !description.dataset.trwsEnhanced) {
    description.dataset.trwsEnhanced = 'true';

    if (description.textContent.includes('AMPA')) {
      const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (/\bAMPA\b/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/\bAMPA\b/g, 'APMA');
      }
    }

    const labelOf = (p) => {
      const strong = p.querySelector('strong, b');
      if (!strong || p.firstElementChild !== strong) return '';
      return strong.textContent.toUpperCase().replace(/[’']/g, "'").replace(/\s+/g, ' ').trim();
    };
    const stripLabel = (p) => {
      const clone = p.cloneNode(true);
      clone.querySelector('strong, b')?.remove();
      const first = clone.firstChild;
      if (first && first.nodeType === Node.TEXT_NODE) first.nodeValue = first.nodeValue.replace(/^[\s:.…–-]+/, '');
      return clone.innerHTML.trim();
    };

    const found = {};
    Array.from(description.children).forEach((el) => {
      if (el.tagName !== 'P') return;
      const label = labelOf(el);
      if (label.startsWith('GURU TIP')) found.guru = found.guru || el;
      else if (label.startsWith('TECH TIP')) found.tech = found.tech || el;
      else if (label.startsWith("DON'T BUY") || label.startsWith('DONT BUY')) found.dont = found.dont || el;
      else if (label.startsWith('BUY THIS')) found.buy = found.buy || el;
    });

    if (found.guru || found.buy || found.dont) {
      const card = document.createElement('section');
      card.className = 'trws-guru';
      card.setAttribute('aria-label', 'Fit Guru take');

      let html = '<p class="trws-guru__eyebrow">The Fit Guru take</p>';
      if (found.guru) html += `<p class="trws-guru__quote">${stripLabel(found.guru)}</p>`;
      if (found.buy || found.dont) {
        html += '<div class="trws-guru__verdict">';
        if (found.buy)
          html += `<div class="trws-guru__col trws-guru__col--buy"><p class="trws-guru__label">Buy this if</p><p>${stripLabel(found.buy)}</p></div>`;
        if (found.dont)
          html += `<div class="trws-guru__col trws-guru__col--skip"><p class="trws-guru__label">Skip it if</p><p>${stripLabel(found.dont)}</p></div>`;
        html += '</div>';
      }
      card.innerHTML = html;

      [found.guru, found.buy, found.dont].forEach((el) => el?.remove());
      description.prepend(card);
      if (found.tech) found.tech.classList.add('trws-tech-tip');
    }
  }

  const specs = root.querySelector('[data-trws-specs]');
  if (specs && description) {
    const guru = description.querySelector('.trws-guru');
    if (guru) guru.after(specs);
    else description.prepend(specs);
  }
  if (specs) specs.hidden = false;
})();
